module.exports = __webpack_public_path__ + "html/video-gallery_09986f47ec965f9c2db730cd5e97eca0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/video-gallery.html
// module id = 1Z0F
// module chunks = 1